import { forwardRef } from 'react';
import { IconHeartBold, IconHeartSolid } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import { PDPCustomAttributeKeys } from '@common/test-automation';

interface LikeButtonProps {
  isSaved?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  visible?: boolean;
}

export const LikeButton = forwardRef<HTMLElement, LikeButtonProps>(({ isSaved, onClick, disabled }, ref) => {
  return (
    <IconWrapper
      onClick={onClick}
      aria-disabled={disabled}
      disabled={disabled}
      data-custom-ta-key={PDPCustomAttributeKeys.PDP_LIKE_BUTTON_6}
      aria-label='찜하기'
      ref={(node) => {
        if (typeof ref === 'function') {
          ref(node);
        } else if (ref) {
          ref.current = node;
        }
      }}
    >
      {isSaved ? (
        <IconHeartSolid width={28} height={28} v3Color='red200' />
      ) : (
        <IconHeartBold width={28} height={28} v3Color='gray700' />
      )}
    </IconWrapper>
  );
});
const IconWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 36px;
  margin: 5px 16px 5px 4px;
  visibility: visible;

  transition: all 100ms linear;

  border-radius: ${vars.cornerRadius[8]};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: ${vars.color.buttonSurfaceHovered};
    }
  }
  @media (hover: none) {
    transition: none;
  }
  &:active {
    background-color: ${vars.color.buttonSurfacePressed};
  }
`;
